import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import EHLAIHomePageEnhanced from './pages/EHLAIHomePageEnhanced';
import Login from './components/Login';
import Register from './components/Register';
import PaymentPage from './components/Payment/PaymentPage';
import PaymentResult from './components/Payment/PaymentResult';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<EHLAIHomePageEnhanced />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Payment Routes */}
        <Route path="/pay-bill/:qrcode" element={<PaymentPage />} />
        <Route path="/payment-result" element={<PaymentResult />} />

        {/* Redirect any unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;